var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-thumbnail",style:(`background-image: url('${_vm.thumbnail}')`),attrs:{"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }